import { render, staticRenderFns } from "./TextAction.vue?vue&type=template&id=37593d6c&scoped=true&"
import script from "./TextAction.vue?vue&type=script&lang=js&"
export * from "./TextAction.vue?vue&type=script&lang=js&"
import style0 from "./TextAction.vue?vue&type=style&index=0&id=37593d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37593d6c",
  null
  
)

export default component.exports